export default __webpack_public_path__ + "locales/pt/Common.json?hash=cf006f176dc95dd4ae9950f3b57f1e9f";